import { parseISO } from 'date-fns';

import type { CampaignType } from './types';

export function getStartDate(campaign: CampaignType) {
  const { startDateTime } = campaign;
  return parseISO(startDateTime ?? '');
}
